import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/img/home/fdkeji.jpg'
import _imports_1 from '../../../public/img/home/weix.png'


const _withScopeId = n => (_pushScopeId("data-v-76b753e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "footer-banner"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"rgba(0,0,0,1)","letter-spacing":"2px"} }, "我需要咨询产品&服务与解决方案", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 在线咨询客服")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "to_right" }, null, -1))
const _hoisted_5 = { class: "footer-content" }
const _hoisted_6 = { class: "content-top" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { style: {"color":"rgba(0,0,0,1)","font-weight":"700"} }
const _hoisted_9 = { class: "content-bottom" }
const _hoisted_10 = { class: "left" }
const _hoisted_11 = { style: {"color":"rgba(0,0,0,1)"} }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"right\" data-v-76b753e3><div style=\"display:flex;\" data-v-76b753e3><div style=\"display:flex;flex-direction:column;\" data-v-76b753e3><p class=\"title\" style=\"color:rgba(0,0,0,1);font-weight:700;font-size:0.9rem;\" data-v-76b753e3>关注分蛋科技</p><img src=\"" + _imports_0 + "\" alt=\"分蛋公众号\" data-v-76b753e3></div><div style=\"display:flex;flex-direction:column;margin-left:3rem;\" data-v-76b753e3><p class=\"title\" style=\"color:rgba(0,0,0,1);font-weight:700;font-size:0.9rem;\" data-v-76b753e3>联系分蛋科技</p><img src=\"" + _imports_1 + "\" alt=\"分蛋科技\" data-v-76b753e3></div></div><p class=\"desc\" style=\"color:rgba(0,0,0,0.7);margin:0.3rem 0;font-weight:500;\" data-v-76b753e3>添加分蛋科技公众号、小程序， 关注相关行业资讯</p><p data-v-76b753e3><span class=\"desc\" style=\"color:rgba(0,0,0,0.7);font-weight:500;\" data-v-76b753e3>咨询热线：</span><span class=\"tel\" style=\"color:rgba(0,0,0,1);font-weight:100;font-family:fantasy;\" data-v-76b753e3>400-088-0991</span></p></div>", 1)
const _hoisted_13 = { class: "business-license" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font_yy" }, "营业执照：", -1))
const _hoisted_15 = {
  key: 0,
  class: "ifShowYY"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "ifshowImg",
  src: "https://static.91fd.com/guanwang/magnifyBusinessLicense.png",
  alt: ""
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  style: {"color":"rgba(0,0,0,1)","font-family":"emoji"},
  class: "beian",
  href: "https://beian.miit.gov.cn/#/Integrated/index",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("©Copyright 2023 91fd.com 沪ICP备16030074号")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$route.path === '/')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("button", {
            class: "butt",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goWayToLink && _ctx.goWayToLink(...args))),
            style: {"color":"rgba(0,0,0,1)","letter-spacing":"2px"}
          }, [
            _hoisted_3,
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      visible: _ctx.dialogVisible,
      onHidden: _ctx.hidden
    }, null, 8, ["visible", "onHidden"]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: index
          }, [
            _createElementVNode("img", {
              src: require(`@/assets/img/${item.img}`),
              alt: item.name
            }, null, 8, _hoisted_7),
            _createElementVNode("span", _hoisted_8, _toDisplayString(item.name), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.linkList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "left-item",
              key: index
            }, [
              _createElementVNode("p", _hoisted_11, _toDisplayString(item.title), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.links, (l_item, l_index) => {
                return (_openBlock(), _createElementBlock("a", {
                  style: {"color":"rgba(0,0,0,0.7)"},
                  key: l_index
                }, _toDisplayString(l_item.label), 1))
              }), 128))
            ]))
          }), 128))
        ]),
        _hoisted_12
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("img", {
          class: "img_yy",
          src: "https://static.91fd.com/guanwang/magnifyBusinessLicense.png",
          alt: "",
          onMouseover: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showImage && _ctx.showImage(...args))),
          onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hideImage && _ctx.hideImage(...args)))
        }, null, 32)
      ]),
      (_ctx.isImageVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
        : _createCommentVNode("", true),
      _hoisted_18
    ])
  ], 64))
}